import { useContext } from 'react'
import ResultContext from '../context/ResultContext'

function ResultStats() {
  const { inventory } = useContext(ResultContext)

  return (
    <div className='text-sm font-medium text-center my-4'>
      <h4>There are {inventory.length} results</h4>
    </div>
  )
}

export default ResultStats
